import { render, staticRenderFns } from "./m-modal-order-confirmation.vue?vue&type=template&id=5175ce4b&scoped=true&"
import script from "./m-modal-order-confirmation.vue?vue&type=script&lang=js&"
export * from "./m-modal-order-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./m-modal-order-confirmation.vue?vue&type=style&index=0&id=5175ce4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175ce4b",
  null
  
)

export default component.exports